
import React from "react";
import { motion } from "framer-motion";
import { Sparkles, ArrowRight } from "lucide-react";
import { Star, Award, Clock, Droplets, Beaker, ShieldCheck, Handshake,Lightbulb, MessageCircleHeart  } from "lucide-react";
  

const galleryImages = [
  {
    src: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/287fd6130_13.jpg?w=1200&q=90",
    title: "Reception Area",
    category: "Reception"
  },
  {
    src: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/831601306_14.jpg?w=1200&q=90",
    title: "Main Salon Floor",
    category: "Salon"
  },
  {
    src: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/7b593983f_15.jpg?w=1200&q=90",
    title: "Styling Stations", 
    category: "Salon"
  },
  {
    src: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/572e1afba_16.jpg?w=1200&q=90",
    title: "Private Lounge",
    category: "Interior"
  },
  {
    src: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/5e03cef8d_17.jpg?w=1200&q=90",
    title: "Reception", // Updated title
    category: "Reception" // Updated category
  },
  {
    src: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/1d99ea153_24.jpg?w=1200&q=90",
    title: "Treatment Corridor",
    category: "Interior"
  },
  {
    src: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/601ccd748_1.jpg?w=1200&q=90",
    title: "Massage Room",
    category: "Treatment"
  },
  {
    src: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/0d0096c79_2.jpg?w=1200&q=90",
    title: "Spa Suite",
    category: "Treatment"
  },
  {
    src: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/664dc3f67_15.jpg?w=1200&q=90",
    title: "Relaxation Room",
    category: "Treatment"
  }
];

const expertisePillars = [
  {
    icon: Lightbulb,
    title: "رؤيـتـنـا",
    description: "أن نكون الوجه الإبداعي الأول في صناعة التسويق والإعلان في المملكة والخليج، ونُحدث نقلة نوعية في طريقة تفاعل الجمهور مع العلامات التجارية."
  },
  {
    icon: MessageCircleHeart,
    title: "رسـالـتـنـا",
    description: "أن نحول الفكرة إلى تجربة، والإعلان إلى تأثير، والعلامة التجارية إلى قصة تُلهم جمهورها وتبقى في الذاكرة."
  },
  {
    icon: Handshake,
    title: "قـيـمـنـا",
    description: "الإبداع، الاحترافية، الشفافية، الالتزام، والعمل الجماعي هي القيم التي نبني عليها كل مشروع وكل علاقة مع عملائنا."
  }
];

export default function Gallery() {
  return (
    <div className="pt-32 pb-24 bg-gradient-to-b from-[#e8e9eb] to-white min-h-screen">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Page Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          
          <h1 className="font-cairo font-medium text-[length:var(--font-h1)] text-[#141d3c] mb-6 leading-tight">
زان للتسويق والدعاية والإعلان          </h1>
          
          <p className="font-cairo text-xl text-gray-600 max-w-3xl mx-auto leading-[1.618]">
مُنـذ عام 2012 ونحـن نُعيـد تعريف التسويـق ولإعـلان برؤية سعـوديـة عصريـة تجمع بين الإبداع، التقنية، والنتائج.          </p>
        </motion.div>
  {/* Founder's Section */}
        <section className="mb-24">
          <div className="grid lg:grid-cols-12 gap-12 items-center bg-white rounded-3xl p-8 lg:p-12 shadow-2xl shadow-[#141d3c]/10 border border-[#141d3c]/20">
            {/* Founder Image */}
            <motion.div 
              className="lg:col-span-5"
              initial={{ opacity: 0, scale: 0.8, x: -50 }}
              animate={{ opacity: 1, scale: 1, x: 0 }}
              transition={{ duration: 1, ease: "easeOut", delay: 0.2 }}
            >
              <div className="rounded-3xl overflow-hidden shadow-xl aspect-[4/5]">
                <img
                  src="https://imgg.io/images/2025/12/02/0251e4c2a56f54119a0f33ad4f6f0ed5.png"
                  alt="ZAN"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </motion.div>
            
            {/* Founder's Story */}
            <motion.div 
              className="lg:col-span-7"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, ease: "easeOut", delay: 0.4 }}
            >
              <h2 className="font-cairo text-3xl lg:text-4xl font-bold text-[#141d3c] mb-2"></h2>
              <p className="font-cairo text-lg text-[#141d3c] font-medium mb-6"></p>
              <div>
                   <h3 className="font-cairo text-center text-xl lg:text-2xl font-bold text-[#141d3c] mb-4 border-l-4 border-[#141d3c] pl-4">هُـنـا تـبـدأ حكـايـتـنـا</h3>
                </div>
              <div className="space-y-6 font-cario text-gray-700 leading-relaxed text-base lg:text-lg">
                <p className="font-cairo mb-4">
بدأت زان للتسويق والدعاية والإعلان رحلتها عام 2012 من فكرة سحابية صغيرة، انطلقت من الإيمان بأن التسويق لم يعد إعلاناً عابرًا، بل تجربة متكاملة تبني حضورًا وتترك أثرًا.                </p>
                <div>
                  <p className="font-cairo mb-4">
وفي عام 2013 أطلقت زان أولى توسعاتها الفعلية بافتتاح مطبعتها المتكاملة المجهزة بأحدث التقنيات الطباعية، لتصبح أحد أهم أذرع الشركة في تنفيذ مشاريع العلامات التجارية بجودة فائقة ودقة عالية.                  </p>
<p className= "font-cairo">واصلت زان مسيرتها لتصبح اليوم منظومة تسويقية متكاملة تجمع تحت سقفها الإبداع، الإنتاج، الطباعة، والاستشارات التسويقية المتخصصة. </p>
                  <h3 className="text-center font-mono text-xl lg:text-3xl font-bold text-[#141d3c] mb-5 border-l-4 border-[#141d3c] pl-8">2025 - 2026</h3>

                  <ul className="font-cairo space-y-3 list-none pl-2 text-base">
                    <li className="flex items-start"> <ShieldCheck className="font-cairo w-5 h-5 text-[#141d3c] mr-3 mt-1 flex-shrink-0" /><span>  في عام 2025 افتتحت زان فرعها الجديد في محافظة القنفذة، وتستعد خلال عام 2026 لافتتاح فرعها الثالث في المنطقة الجنوبية – جازان، ضمن خطة توسع مدروسة تهدف إلى تعزيز الانتشار الإقليمي. </span></li>
                  </ul>
                  <p className="font-cairo font-semibold text-center mt-4">
تُدار زان اليوم من مقرها الرئيسي في مدينة جدة، وتضم فرقًا متخصصة في التسويق الرقمي، الإنتاج الإعلامي، التصميم، الفعاليات، إلى جانب المطبعة وفريق إداري وفني محترف.                  </p>
                </div>

                <div>
                   <h3 className="font-cairo text-center text-xl lg:text-2xl font-bold text-[#141d3c] mb-4 border-l-4 border-[#141d3c] pl-4">زان اليوم ليست مجرد وكالة</h3>
                   <p className="font-cairo font-semibold text-center" >
 زان كيان تسويقي متكامل يواكب التطور ويصنع قصص نجاح تُروى في السوق السعودي والخليجي.                   </p>
                </div>
              </div>

              {/* Signature */}
              <p className="font-serif text-3xl text-[#141d3c] mt-8"></p>
            </motion.div>
          </div>
        </section>
        
    

 <section className="mb-24 text-center">
            <h2 className="font-cairo text-3xl font-bold text-[#141d3c] mb-12">جوهر الإبداع والتميز</h2>
            <div className="font-cairo grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
                {expertisePillars.map((pillar, index) => (
                    <motion.div
                        key={pillar.title}
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: index * 0.2 + 0.5, ease: "easeOut" }}
                        className="font-cairo bg-white p-8 rounded-3xl shadow-lg border border-[#141d3c]/20 flex flex-col items-center"
                    >
                        <div className="w-16 h-16 bg-[#141d3c]/10 rounded-full flex items-center justify-center mb-4">
                            <pillar.icon className="w-8 h-8 text-[#141d3c]" />
                        </div>
                        <h3 className="font-cairo text-xl font-semibold text-[#141d3c] mb-2">{
                        pillar.title}</h3>
                        <p className="text-gray-600 text-sm text-center leading-relaxed">{pillar.description}</p>
                    </motion.div>
                ))}
            </div>
        </section>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="text-center mt-16"
        >
          <div className="bg-white rounded-3xl p-12 shadow-lg border border-[#141d3c]/20">
            <h2 className="font-cairo text-[length:var(--font-h2)] font-bold text-[#141d3c] mb-4">
             لحظة ارتقاء علامتك تبدأ من هنا
            </h2>
            <p className="font-cairo text-gray-600 mb-8 max-w-2xl mx-auto leading-[1.618]">
             مع زان، نصنع لك رحلة إبداعية متكاملة … من الحملات الإعلانية المؤثرة إلى الهويات البصرية اللي تترك بصمة. خلي فكرتك تتحول لواقع يلفت الأنظار.
            </p>
            <button 
              onClick={() => window.dispatchEvent(new CustomEvent('open-booking-modal'))}
              className="font-cairo bg-[#141d3c] text-white px-8 py-4 rounded-full font-medium hover:bg-[#ee9805] transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl">
ابـدأ معنا الآن            </button>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
